import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { PostHogErrorBoundary } from "posthog-js/react";
import AppCrashFallback from "../utils/AppCrashFallback";
import FullPageMessage from "../utils/FullPageMessage";

const RethrowRouteError = () => {
  throw useRouteError();
};

const PageNotFound = () => (
  <FullPageMessage
    title="No encontramos esta página"
    description="Revisá el link o volvé al inicio."
    actionLabel="Ir al inicio"
    onAction={() => window.location.assign("/")}
  />
);

const RouteErrorBoundary = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) return <PageNotFound />;

  return (
    <PostHogErrorBoundary fallback={<AppCrashFallback />}>
      <RethrowRouteError />
    </PostHogErrorBoundary>
  );
};

export default RouteErrorBoundary;
